import { render, staticRenderFns } from "./RecentAudits.vue?vue&type=template&id=8dc539c2&scoped=true&"
import script from "./RecentAudits.vue?vue&type=script&lang=js&"
export * from "./RecentAudits.vue?vue&type=script&lang=js&"
import style0 from "./RecentAudits.vue?vue&type=style&index=0&id=8dc539c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc539c2",
  null
  
)

export default component.exports